module.exports = __webpack_public_path__ + "img_BG_2_for_menu.c4ff97613965bd15a9ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_BG_2_for_menu.png
// module id = 1484
// module chunks = 0